export default __webpack_public_path__ + "static/media/top.b8a79935.png";